export enum CacheKey {
  DismissedLinkinbioMavelyAuthModal = 'dismissed-linkinbio-mavely-auth-modal',
  DismissedLinkinbioMavelyCreateLinksModal = 'dismissed-linkinbio-mavely-create-links-modal',
  OpenedCheckoutFromPricingReferral = 'opened-checkout-from-pricing-referral',
  LinkinbioBasicDisplayDeprecationWarning = 'linkinbio-basic-display-deprecation-warning'
}
